import styled from 'styled-components';
import { UiColors } from 'assets/styles/old/global';
import { deviceLess } from '_constants/DEVICES';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 15px;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

export const RadioInput = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid ${UiColors.forestColor};
  border-radius: 50%;
  background: var(--white);
  cursor: pointer;
  margin: 0;
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s ease;

  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${UiColors.forestColor};
  }
`;

export const RowLabel = styled.label`
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
`;

export const InlineText = styled.span`
  font-size: 14px;
  white-space: nowrap;
`;

export const SelectWrapper = styled.div`
  width: ${({ $wide }) => ($wide ? '180px' : '130px')};

  @media ${deviceLess.tablet} {
    width: ${({ $wide }) => ($wide ? '150px' : '110px')};
  }
`;
